import { render, staticRenderFns } from "./TimetableHeaderParts.vue?vue&type=template&id=163b2770&scoped=true"
import script from "./TimetableHeaderParts.vue?vue&type=script&lang=ts"
export * from "./TimetableHeaderParts.vue?vue&type=script&lang=ts"
import style0 from "./TimetableHeaderParts.vue?vue&type=style&index=0&id=163b2770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b2770",
  null
  
)

export default component.exports